
import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { CloseSvg, SearchSvg } from '../svgs/Svgs'
import { AllFilterType } from './types';

interface Props {
    applyFilter: (filters: AllFilterType) => void;
    allFilters: AllFilterType;
    setAllFilters: (filters: AllFilterType) => void;
    placeholder?: string;
}

const Search: FC<Props> = ({ applyFilter, allFilters, setAllFilters, placeholder }) => {

    const value = useMemo(() => allFilters?.searchFilter || '', [allFilters?.searchFilter])
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [inputActive, setInputActive] = useState(false)

    useEffect(() => {
        const searchFilter = document.querySelector('.custom__search__filter__container')
        const clickedOutside = (e: any) => {
            if (!searchFilter) return
            else if (!searchFilter?.contains(e.target)) {
                setInputActive(false)
            }
        }
        document.addEventListener('mousedown', clickedOutside)
        return () => {
            document.removeEventListener('mousedown', clickedOutside)
        }
    }, [])

    const handleSearchClick = () => {
        if (!inputActive) {
            inputRef.current?.focus();
            setInputActive(true)
        } else {
            handleSearch('')
            setInputActive(false)
        }
    }

    const handleSearch = (value: string) => {
        const all_filters: AllFilterType = { ...allFilters, searchFilter: value }
        if (value === '') {
            delete all_filters.searchFilter
        }
        setAllFilters(all_filters)
        applyFilter(all_filters)
    }

    return (
        <div className={`custom__search__filter__container ${inputActive && 'active'}`}>
            <button className={`search__icon__container ${(value !== '' && !inputActive) && 'active'}`} onClick={handleSearchClick}>
                {inputActive ? <CloseSvg /> : <SearchSvg />}
            </button>
            <input
                type='text'
                className='custom__search__filter__input'
                placeholder={placeholder || 'Search...'}
                value={value}
                onChange={(e) => handleSearch(e.target.value)}
                autoComplete='off'
                ref={inputRef}
            />
            {inputActive &&
                <div className={`search__icon__container`}>
                    <SearchSvg />
                </div>
            }
        </div>
    )
}

export default Search